import { render, staticRenderFns } from "./DepartamentEdit.vue?vue&type=template&id=5235f6b0"
import script from "./DepartamentEdit.vue?vue&type=script&lang=js"
export * from "./DepartamentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports